/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgInvoiceExtraction = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M4 2H3v14h3v4h12.586l-1.293 1.293 1.414 1.414 3-3 .707-.707-.707-.707-3-3-1.414 1.414L18.586 18H8v-2h8V5.586l-.293-.293-3-3L12.414 2H4zm4 12H5V4h6.586L14 6.414V14H8zm2-6H7V6h3v2zm-3 4h5v-2H7v2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgInvoiceExtraction as InvoiceExtraction };
